import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Card,
  Skeleton,
  Alert,
  Empty,
  Typography
} from 'antd';
import {
  FileTextOutlined,
  ReloadOutlined
} from '@ant-design/icons';
import {
  getDocumentationPrivacy,
  clearMessages
} from '../features/account/documentationPrivacySlice';
import { useRichTextStyles } from '../utils/useRichTextStyles'; // Add this import

const { Title, Paragraph } = Typography;

const Documentation = () => {
  const dispatch = useDispatch();
  useRichTextStyles(); // Add this hook
  
  const { documentation, loading, error, lastUpdated } = useSelector(
    (state) => state.documentationPrivacy
  );

  useEffect(() => {
    dispatch(getDocumentationPrivacy());
  }, [dispatch]);

  useEffect(() => {
    if (error) {
      dispatch(clearMessages());
    }
  }, [error, dispatch]);

  if (loading) {
    return (
      <div className="space-y-6">
        <Card className="shadow-soft border border-border-light rounded-xl">
          <div className="flex items-center space-x-3 mb-6">
            <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-green-600 rounded-full flex items-center justify-center">
              <FileTextOutlined className="text-xl text-white" />
            </div>
            <div>
              <Title level={2} className="mb-1">Documentation</Title>
              <Paragraph className="text-gray-600 mb-0">
                Application documentation and guides
              </Paragraph>
            </div>
          </div>
          <Skeleton active paragraph={{ rows: 8 }} />
        </Card>
      </div>
    );
  }

  if (error) {
    return (
      <div className="space-y-6">
        <Card className="shadow-soft border border-border-light rounded-xl">
          <Alert
            message="Error Loading Documentation"
            description="There was an error loading the documentation. Please try again."
            type="error"
            showIcon
            action={
              <button
                onClick={() => dispatch(getDocumentationPrivacy())}
                className="flex items-center space-x-1 text-blue-600 hover:text-blue-800"
              >
                <ReloadOutlined />
                <span>Retry</span>
              </button>
            }
          />
        </Card>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <Card className="shadow-soft border border-border-light rounded-xl">
        <div className="flex items-center space-x-3 mb-4">
          <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-green-600 rounded-full flex items-center justify-center">
            <FileTextOutlined className="text-xl text-white" />
          </div>
          <div>
            <Title level={2} className="mb-1">Documentation</Title>
            <Paragraph className="text-gray-600 mb-0">
              Application documentation and guides
            </Paragraph>
          </div>
        </div>
        
        {lastUpdated && (
          <Paragraph className="text-sm text-gray-500 mb-0">
            Last updated: {new Date(lastUpdated).toLocaleString()}
          </Paragraph>
        )}
      </Card>

      {/* Content */}
     <Card className="shadow-soft border border-border-light rounded-xl">
    {documentation ? (
      <div 
        className="rich-text-content prose prose-lg max-w-none" // Add rich-text-content class
        dangerouslySetInnerHTML={{ __html: documentation }}
        style={{
          lineHeight: '1.7',
          fontSize: '16px',
          fontFamily: 'Montserrat, sans-serif'
        }}
      />
    ) : (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={
          <div>
            <p>No documentation available</p>
            <p className="text-sm text-gray-500">
              Documentation content will appear here once it's been created.
            </p>
          </div>
        }
      />
    )}
  </Card>
    </div>
  );
};

export default Documentation;